import Caret from './Caret';

export default Caret;
